import { DnsSurface } from "@redotech/crdb-enums/dns/dns-surface";
import { domainRequirementsSchema } from "@redotech/redo-dns-common/schema";

import * as z from "zod";

/**
 * Null for a domain this team has not claimed, so a caller cannot tell a
 * nonexistent domain from someone else's.
 */
export const getDnsRequirements = {
  name: "getDnsRequirements" as const,
  input: z.object({
    domain: z.string(),
    /** Narrows the output only. Values are folded across every surface. */
    surfaces: z.array(z.enum(DnsSurface)).optional(),
    /** Skip the freshness window and ask the zone's own nameservers. */
    force: z.boolean().optional(),
  }),
  output: z.object({ requirements: domainRequirementsSchema.nullable() }),
};
